import { api } from '../../lib/api.ts';

export type LetterheadSlot = 'header' | 'footer';

export interface LetterheadPublic {
  hasHeaderImage: boolean;
  hasFooterImage: boolean;
  footerText: string | null;
}

export interface OrgInfo {
  id: string;
  name: string;
  contactEmail: string;
  letterhead: LetterheadPublic;
}

export const orgSettingsApi = {
  get: () => api.get<{ org: OrgInfo }>('/org').then((r) => r.data.org),
  // Only footer text is editable here; org name/contact are managed in Office.
  patch: (patch: { footerText?: string }) =>
    api.patch<{ letterhead: LetterheadPublic; org: OrgInfo }>('/org', patch).then((r) => r.data.letterhead),
  uploadImage: (slot: LetterheadSlot, file: File) => {
    const fd = new FormData();
    fd.append('image', file);
    return api
      .post<{ letterhead: LetterheadPublic }>(`/org/letterhead/${slot}`, fd)
      .then((r) => r.data.letterhead);
  },
  removeImage: (slot: LetterheadSlot) => api.delete(`/org/letterhead/${slot}`),
  imageUrl: (slot: LetterheadSlot) => `/api/org/letterhead/${slot}/file`,
  // Image previews need the auth header, so fetch as a blob via the api
  // instance and hand back an object URL. The caller must revoke it.
  fetchImageBlobUrl: (slot: LetterheadSlot) =>
    api
      .get(`/org/letterhead/${slot}/file`, { responseType: 'blob' })
      .then((r) => URL.createObjectURL(r.data as Blob)),
};
